import { render } from "./BAvatar.vue?vue&type=template&id=438a7ae4&scoped=true"
import script from "./BAvatar.vue?vue&type=script&lang=js"
export * from "./BAvatar.vue?vue&type=script&lang=js"

import "./BAvatar.vue?vue&type=style&index=0&id=438a7ae4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-438a7ae4"]])

export default __exports__